import { SkeletonBox } from '@/components/skeleton/skeleton-box';
import { Inline } from '@/ui/line/line';
import { useTemplates } from '@/features/settings/manage-templates/use-templates.query';
import { GeneralTag } from '@/ui/tag/general-tag';
import { Icon } from '@/ui/icons/icon';
import { useTranslation } from 'react-i18next';
import { styled } from 'goober';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { useSidebars } from '@/hooks/use-sidebars';

export const ProjectTemplatesList = () => {
  const { t } = useTranslation('default', {
    keyPrefix: 'templatesSidebar',
  });

  const { toggleTemplatesSidebar } = useSidebars();
  const { data = [], isLoading, isFetched } = useTemplates();

  if (isLoading) {
    return <SkeletonBox width="150px" height="20px" />;
  }

  if (isFetched && data?.length === 0) {
    return null;
  }

  return (
    <Flexbox name="project-templates-container" gap="8px" alignItems="center">
      <Typography>{t`templates`}</Typography>

      <Inline justifyContent="flex-start">
        {data
          .filter(template => template.link)
          .map(template => (
            <GeneralTag
              key={template.id}
              variant="gray"
              onClick={toggleTemplatesSidebar}
            >
              <Icon icon="ArrowDownFromBracket" />
              {t([`fileTypes.${template.fileType}.name`])}
            </GeneralTag>
          ))}
      </Inline>
    </Flexbox>
  );
};

const Typography = styled('p')`
  ${({ theme }) => theme.typography.project.template}
`;
